var map = {
	"./video-carousel.de-CH.json": 1602,
	"./video-carousel.de-DE.json": 1603,
	"./video-carousel.en-CA.json": 1604,
	"./video-carousel.en-GB.json": 1605,
	"./video-carousel.en-IN.json": 1606,
	"./video-carousel.en-ME.json": 1607,
	"./video-carousel.en-US.json": 1608,
	"./video-carousel.es-EM.json": 1609,
	"./video-carousel.es-ES.json": 1610,
	"./video-carousel.fr-BE.json": 1611,
	"./video-carousel.fr-CA.json": 1612,
	"./video-carousel.fr-CH.json": 1613,
	"./video-carousel.nl-BE.json": 1614,
	"./video-carousel.nl-NL.json": 1615,
	"./video-carousel.pl-PL.json": 1616,
	"./video-carousel.pt-BR.json": 1617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1601;